import { styled, Typography } from "@mui/material";


export const StyledBreadCrumb = {
  BreadCrumbContainer: styled('div')(({ theme }) => ({
    display: "flex",
    margin: "15px",
    position: "relative",
    zIndex: 1000,
  })),
  BreadCrumb: styled('div')(({ theme, selected }) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    borderRadius: 10,
    height: "20px",
    marginTop: 10,
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.text.primary,
    padding: theme.spacing(0, 2),
    "&:hover": {
      backgroundColor: theme.palette.grey[400],
    },
    ...(selected ? {
      cursor: "default",
      backgroundColor: theme.palette.primary.main,
      color: "white",
      "&:hover": {
        backgroundColor: theme.palette.primary.light,
      },
    } : {})
  })),
  Icon: styled('div')(({ theme }) => ({
    marginTop: 10,
  })),
  Label: styled(Typography)(({ theme, disabled }) => ({
    ...(disabled ? {
      textDecoration: "line-through",
      cursor: "default",
    } : {})
  })),
}